import { Navigate, useSearchParams } from 'react-router';

export const SplitScreenModuleRedirect = () => {
  const [searchParams] = useSearchParams();
  const moduleId = searchParams.get('moduleId');

  const path = moduleId ? `/learning/modules/${moduleId}` : '/learning';

  const prompt = searchParams.get('prompt');

  const params = new URLSearchParams();
  if (prompt) {
    params.set('prompt', prompt);
  }

  const query = params.toString();
  const target = query ? `${path}?${query}` : path;

  return <Navigate to={target} replace />;
};
